import { getLocaleByLanguageCode as e } from "../translations/language-utils.mjs";
import { LocaleContext as t } from "../i18n.mjs";
import { getCountryData as n, getCountryName as r } from "./get-country-data.mjs";
import { useCallback as i, useContext as a, useMemo as o } from "react";
import { LocaleEnum as s } from "@systemeio/types";
//#region src/countries/use-localized-countries.ts
var c = () => {
	let { currentLanguageCode: c } = a(t) ?? {}, l = o(() => c ? e(c) : s.ENGLISH, [c]);
	return {
		countryData: o(() => n(l), [l]),
		getCountryName: i((e) => r(e, l), [l])
	};
};
//#endregion
export { c as useLocalizedCountries };
